module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/vegetarian__376c7918223a4a2ad9f4c0b67a2312a2.png";